import { SyntheticEvent, forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import '../navbar/Navbar.css';
import { NotificationService } from "../../service/notifications.service";

const NotificationBadge = forwardRef((props: any, ref: any) => {

  useImperativeHandle(ref, () => ({
    log() {
      console.log("child function");
    }
  }));

  const notificationService = new NotificationService();

  const [notificationCount, setNotificationCount] = useState(0);

  const params = useParams();
 
  const [status, setStatus] = useState(1);

  const location = useLocation();

  var counter = 1 ;

  const countDown = ()=> {
    
  //  counter = counter +1;
    if (counter == 2) { // previous 6
      
      counter = 1
      fetchCount()
    } else {
      counter = counter + 1;
    }
    // let count =  counter;
     //setNotificationCount(count)
  }
 


  const fetchCount = ()=> {
    notificationService.getNotificationCount().then(data => {
      const res = data;

      //alert("count "+ res.entApprovalNotificationCnt);
      console.log('countttttt -- ', res.entApprovalNotificationCnt)
      
      setNotificationCount(res.entApprovalNotificationCnt + res.orderApprovalNotificationCnt)   

  });
  }

  
  let loaddatacalled = false;
  useEffect(() => {

    console.log("badgeeeeeeeeeeee");

    if (props!=null) {
        setNotificationCount(props.count)
    }
    if (!loaddatacalled) {

        setInterval(countDown, 15000);
      loaddatacalled = true;
      
    }
  }, []);


  return (
    <div className="">
  
       <span className="badge">{ notificationCount +"" }</span>

    </div>
  );
})

export default NotificationBadge;
